import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../wrappers';
import uikit from '../../../project/uikit/uikit.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../common/utils/styles';
import css from './FieldInfoElement.module.scss';

const FieldInfoElement = ({ children, compStyle, customDataStyle = {} }) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    const innerStyles = {
        errorWrapper: {
            display: 'flex',
            alignItems: 'flex-start',
            marginTop: '8px'
        },
        errorText: {
            flexGrow: '1',
            color: 'var(--darkHalfTransparentColor)'
        }
    };

    return (
        <div style={{ ...innerStyles.errorWrapper, ...stylers.wrapper }} className={classnames(classes.wrapper)}>
            {svgSprite('warning-circle', {
                ...customDataStyle,
                className: classnames(css.innerStyles__icon, classes.icon),
                style: { ...stylers.icon }
            })}
            <div
                className={classnames(uikit.tiny, css.innerStyle__text, classes.text)}
                style={{ ...innerStyles.errorText, ...stylers.text }}
            >
                {children}
            </div>
        </div>
    );
};

FieldInfoElement.propTypes = { compStyle: PropTypes.object };

export default FieldInfoElement;
